import Vue from 'vue';
import { getData } from '../../utils/storage';
export default Vue.extend({
    name: 'contractAgreement',
    data: function () {
        return {
            agreementData: {},
        };
    },
    created: function () {
        this.agreementData = getData('agreement');
    },
    methods: {
        changeDate: function (value) {
            var date = this.agreementData[value].split('-');
            return date[0] + '年' + date[1] + '月' + date[2] + '日';
        },
    },
});
